import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { BehaviorSubject, combineLatest, Observable } from "rxjs";
import { finalize, map, shareReplay, startWith } from "rxjs/operators";
import { ISelectableWorkOrder } from "src/app/admin/projects/project-manage/models/ISelectableWorkOrder";
import { IWorkOrder } from "src/app/admin/work-orders/models/IWorkOrder";
import { WorkOrderService } from "src/app/admin/work-orders/work-order.service";

@Component({
  selector: "app-choose-workorder",
  templateUrl: "./choose-workorder.component.html",
  styleUrls: ["./choose-workorder.component.scss"],
})
export class ChooseWorkorderComponent implements OnInit {
  @Input() selectedWorkOrders: IWorkOrder[];

  private loadingSubject = new BehaviorSubject<boolean>(false);
  private savingSubject = new BehaviorSubject<boolean>(false);

  private availableWorkOrders: ISelectableWorkOrder[] = [];

  loading$ = this.loadingSubject.asObservable();
  saving$ = this.savingSubject.asObservable();
  keywordFilter = new FormControl("");

  workOrders$: Observable<ISelectableWorkOrder[]>;
  constructor(
    private activeModal: NgbActiveModal,
    private workOrderService: WorkOrderService
  ) {}

  ngOnInit() {
    this.loadingSubject.next(true);
    const allWorkOrders$ = this.workOrderService.getWorkOrders().pipe(
      finalize(() => this.loadingSubject.next(false)),
      map((workOrders) => {
        return workOrders
          .map((workOrder) => {
            const selectedWorkOrder = this.selectedWorkOrders.find(
              (wo) => workOrder.id === wo.id
            );
            const isSelected = !!selectedWorkOrder;
            const canBeToggled = !(
              isSelected && selectedWorkOrder.timeEntries.length > 0
            );
            const selectableWorkOrder: ISelectableWorkOrder = Object.assign(
              { selected: isSelected, canBeToggled },
              workOrder
            );
            return selectableWorkOrder;
          })
          .sort(this.sortBySelectedThenName);
      }),
      shareReplay(1)
    );

    allWorkOrders$.subscribe((projects) => {
      this.availableWorkOrders = projects;
    });

    const keywordFilter$ = this.keywordFilter.valueChanges.pipe(startWith(""));

    this.workOrders$ = combineLatest([allWorkOrders$, keywordFilter$]).pipe(
      map(([workOrders, keyword]) => {
        return workOrders.filter((workOrder) =>
          this.search(workOrder, keyword)
        );
      })
    );
  }
  toggle(workOrder: ISelectableWorkOrder) {
    if (workOrder.canBeToggled) {
      workOrder.selected = !workOrder.selected;
    }
  }
  close() {
    this.activeModal.close(
      this.availableWorkOrders.filter((wo) => wo.selected)
    );
  }
  dismiss() {
    this.activeModal.dismiss();
  }
  private search(workOrder: ISelectableWorkOrder, text: string) {
    const keyword = text.toLowerCase();
    // TODO this wont be quite as cool as the vs code file search.. update that
    return (
      workOrder.name.toLowerCase().includes(keyword) ||
      workOrder.description.toLowerCase().includes(keyword)
    );
  }
  // TODO this can be weird on the project manage page because there is a separate work order Order.
  // this means that sorting by selected > name wont neccesarily match the order that shows up on the page after selection
  private sortBySelectedThenName = (
    a: ISelectableWorkOrder,
    b: ISelectableWorkOrder
  ) => {
    if (a.selected && !b.selected) {
      return -1;
    }
    if (!a.selected && b.selected) {
      return 1;
    }
    return this.workOrderService.sortByName(a, b);
  };
}
